// 轮播图管理
export default [
  {
    path: "/activityManage",
    meta: { title: "活动管理" },
    component: () => import("../views/activityManage/index"),
    children: [
      {
        path: "/activityManage/activityList",
        name: "activityList",
        meta: { title: "活动列表", isMenu: true },
        component: () => import("../views/activityManage/activityList.vue"),
      },{
        path: "/activityManage/activityClass",
        name: "activityClass",
        meta: { title: "活动分类", isMenu: true },
        component: () => import("../views/activityManage/activityClass.vue"),
      },{
        path: "/activityManage/detail/addEditActivity",
        name: "addEditActivity",
        meta: { title: "新增/编辑" },
        component: () => import("../views/activityManage/detail/addEditActivity.vue"),
      },{
        path: "/activityManage/detail/activityRegisterList",
        name: "activityRegisterList",
        meta: { title: "报名列表" },
        component: () => import("../views/activityManage/detail/activityRegisterList"),
      },{
        path: "/activityManage/detail/activityRegisterDet",
        name: "activityRegisterDet",
        meta: { title: "报名详情" },
        component: () => import("../views/activityManage/detail/activityRegisterDet"),
      },
    ],
  },
]
